import { memo, FC } from 'react'
import {
  // Select,
  InputGroup,
  // InputLeftAddon,
  Input,
} from '@chakra-ui/react'
import { DynamicFieldProps } from '../..'

const DatetimeInputFilterField: FC<DynamicFieldProps> = ({
  name,
  register,
}) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      {/* <InputLeftAddon p={0} width="max-content">
        <Select placeholder="Selecione uma regra" roundedRight="none" {...register(`${name}_rule`)}>
          <option value="HAVE">Contém</option>
          <option value="NOT_HAVE">Não contém</option>
        </Select>
      </InputLeftAddon> */}

      <Input {...register(name)} inputMode="numeric" />
    </InputGroup>
  )
}

export default memo(DatetimeInputFilterField)
